import { Component, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { IBetslipOverAskPickComponentProps, IBetslipOverAskPickListProps } from '../models/over-ask.model';

@Component({
    template: '',
    standalone: false,
})
export class BetslipOverAskPickListBaseComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    private _props: IBetslipOverAskPickListProps = { overAskBets: [] };
    @Input() set props(value: IBetslipOverAskPickListProps) {
        this._props = value;
        this.pickViewModel = BetslipOverAskPickListBaseComponent.buildPicksViewModel(value);
    }

    @Input() overAskFlowState: OverAskFlowState;

    pickViewModel: IBetslipOverAskPickComponentProps[];
    private static buildPicksViewModel(props: IBetslipOverAskPickListProps): IBetslipOverAskPickComponentProps[] {
        return props.overAskBets.flatMap((b) =>
            b.picks.map((p) => ({
                overAskBet: {
                    type: b.type,
                    initialStake: b.stake,
                    isRemoved: b.isRemoved,
                    counterOfferStake: b.changes.stake,
                },
                overAskPick: p,
            })),
        );
    }

    isMultiSingle(): boolean {
        return this._props.overAskBets.length > 1; // For now just check if more than one bet.
    }

    isPendingState(): boolean {
        return this.overAskFlowState === OverAskFlowState.Pending;
    }

    isReviewState(): boolean {
        return this.overAskFlowState === OverAskFlowState.Review;
    }
}
